

import state from './moduleInterventionsState.js'
import mutations from './moduleInterventionsMutations.js'
import actions from './moduleInterventionsActions.js'
import getters from './moduleInterventionsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

